module.exports = __webpack_public_path__ + "cf67bef0133ff863a631f6d13d9762da.jpg";